import AppResponse from 'models/AppResponse';

const { AUTH_URL, LOGIN_URL } = require('config/api');
const { default: ApiService } = require('./Api.service');

class AuthServiceClass extends ApiService {
    constructor() {
        super(AUTH_URL);
    }

    async signIn(payload) {
        try {
            const { email, password } = payload;
            const response = await this.doPost(LOGIN_URL, payload);

            return new AppResponse(true, response.msg, { token: response.token, user: response.user });
        } catch (err) {
            console.error(err);

            return new AppResponse(false, err.msg || err.message, err);
        }
    }
}

const AuthService = new AuthServiceClass();

export default AuthService;
